export const state = {
    isLoading: false
};

export const reducer = {
    startLoading: (state) => {
        if ('isLoading' in (state || {})) {
            state.isLoading = true;
        }
    },
    stopLoading: (state) => {
        if ('isLoading' in (state || {})) {
            state.isLoading = false;
        }
    }
};
